import { api } from 'data/api/api'

import { SubmitSupportFeedbackArgs } from '../types/arguments/submit-support-feedback-args'

export const submitSupportFeedback = (args: SubmitSupportFeedbackArgs) =>
  api.post(`/users/${args.userId}/msg_threads/${args.conversationId}/submit_support_feedback`)
